import { Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { unformatDollarString } from "utils/helpers";
import { Badge } from "@chakra-ui/react";

const INTEREST_LABELS = ["Interest", "Default Interest", "Base Rate"];

const ListTable = ({ rows }: { rows: any[] }) => {
  return (
    <UnorderedList listStyleType="none" m="0px" mb="18px" p="0px">
      {rows.map(row => (
        <ListItem key={row.label} py="5px" borderBottomWidth="1px" borderBottomColor="gray.100">
          <Flex justifyContent="space-between">
            <Text fontWeight="500" fontSize="14px" color="black">
              {row.label}
            </Text>
            {INTEREST_LABELS.includes(row.label) && <Text>{row.interestRate}</Text>}

            {row.loanType && INTEREST_LABELS.includes(row.label) && (
              <Badge variant="purple">{row.loanType}</Badge>
            )}
            <Text
              fontSize="16px"
              color={
                !isNaN(unformatDollarString(row.value)) && unformatDollarString(row.value) < 0
                  ? "red"
                  : "secondary"
              }
            >
              {row.value}
            </Text>
          </Flex>
        </ListItem>
      ))}
    </UnorderedList>
  );
};

export default ListTable;
